import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import icTrash from 'assets/images/ic-trash.svg'
import { Button } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'

export const TABLE_CATEGORY_AWARD = {
    name: 'Category Voting',
    column: [
        {
            name: 'Nama Kategori',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Tipe Nominasi',
            key: 'type',
            className: 'capitalize',
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <div className={'flex space-x-3'}>
                    <Button
                        type={'outline'}
                        title={'Edit'}
                        icon={icEditYellow}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}

export const INIT_STATE = {
    name: null,
    type: null,
}
